export enum MongoDbCollection {
  INVENTORY = 'inventory',
  EVENTS = 'events',
  CUSTOMERS = 'customers',
  ADMISSION_GROUPS = 'admissionGroups',
  SALES = 'sales',
  TRACK_UNIQUE_VISITORS = 'trackUniqueVisitors',
  ORGANIZATION_MEMBERS = 'organizationMembers',
  BOOKINGS = 'bookings',
  VENUES = 'venues',
  CUSTOMER_SESSIONS = 'customerSessions',
}
